import Resource from "axios-resource";

export default class AuditResource extends Resource {
    URL = `/v1/audits`;

    constructor(props) {
        super(props);
    }

    query(options) {
        this._url = this.URL + '?expand={expand}&date={date}&company={company}&auditor={auditor}';
        return this.sync('get', '', options);
    };

    put(id, attrs, options) {
        this._url = this.URL + '/{id}?expand={expand}';
        return this.sync('put', attrs, this.applyUrlKeys(id, options));
    }

    fetch(id, options) {
        this._url = this.URL + '/{id}?expand={expand}';
        return this.sync('get', null, this.applyUrlKeys(id, options));
    };

    addCompany(attrs, options) {
        this._url = this.URL + '/add-company';
        return this.sync('post', attrs, options);
    }

    removeCompany(attrs, options) {
        this._url = this.URL + '/remove-company';
        return this.sync('post', attrs, options);
    }
}



// WEBPACK FOOTER //
// ./src/resources/auditResource.js